import {HTTP} from "./util"

let UserProfileWrapper = {

    init: config => {

        return {


            'user': (username) => {
                let user = username;
                return {

                    Exists: async function () {
                        const url = `${config.url}/userprofile/${user}`;
                        let p = Promise.resolve();
                        let response;

                        try {
                            response = await HTTP.head(url);
                            if (response.ok && response.status === 200) {
                                p = Promise.resolve({status: response.status, ok: response.ok})
                            }
                            else {
                                if (response.status === 404) {
                                    p = Promise.reject({status: response.status, ok: response.ok})
                                }
                                else if(response.status >= 500 ){
                                    p = Promise.reject({status : response.status , message : "Backend generated error"});
                                }
                            }
                        } catch (e) {

                            p = Promise.reject({ status : 0 ,  message : e.message })
                        }
                        return p;
                    },
                    Summary: {
                        Get: async function () {
                            const url = `${config.url}/userprofile/${user}/summary`;
                            let p = Promise.resolve();
                            let response;
                            try{
                                response = await HTTP.get(url);
                                if(response.ok){

                                    const json = await response.json();
                                    delete json["_links"];
                                    p = Promise.resolve({status: response.status, ok: response.ok, data : json })

                                }
                                else{
                                    if(response.status === 404){
                                        p = Promise.reject({ status : response.status , message : "Sorry, we can't find that user. Please try another username"})
                                    }
                                    else if(response.status >= 500 ){
                                        p = Promise.reject({status : response.status , message : "Backend generated error"});
                                    }

                                }
                            }
                            catch(e){
                                p = Promise.reject({ status : 500 ,  message : e.message })
                            }
                            return p;
                        },
                    }
                }
            }

        }

    }
};

const UserProfile = (config) => {
    if (config === undefined) throw Error("No config passed in");
    return UserProfileWrapper.init(config);
};

export {
    UserProfile
}